import { removeQueryStringInS3Link } from '@/helpers/s3Helpers';
import { IHomepageTabFooterSection } from '@/interfaces/enterprise-profile/homepage_tab.interface';
import { SocialIcon } from 'design-system/components/Icon';
import SectionLayout from 'layouts/HomepageLayout/SectionLayout';
import Image from 'next/image';

const HomepageFooterSection = ({
  logoUrl,
  footerContent,
}: IHomepageTabFooterSection & { sectionName: string }) => {
  return (
    <div className="relative bg-white py-4">
      <SectionLayout>
        <div>
          <Image
            src={removeQueryStringInS3Link(logoUrl)}
            height={57}
            width={125}
            alt="logo"
            loading="lazy"
            decoding="async"
          />
          <div className="grid grid-cols-1 gap-6 md:grid-cols-3 md:gap-[100px]">
            {footerContent?.map((item, index) => (
              <div key={index} className="col-span-1">
                <p className="mb-5 font-bold">{item.title}</p>

                {item.links.map((link, indexLink) => (
                  <div
                    key={indexLink}
                    className="relative flex items-start justify-start gap-1"
                  >
                    {link.iconName && (
                      <SocialIcon
                        iconName={link.iconName}
                        width={20}
                        height={20}
                      />
                    )}
                    <a
                      href={link.url || ''}
                      target="_blank"
                      rel="noreferrer"
                      className={
                        link.url ? 'cursor-pointer' : 'pointer-events-none'
                      }
                    >
                      <p className="mb-3 break-word-legacy lg:mb-5">
                        {link.title}
                      </p>
                    </a>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </SectionLayout>
    </div>
  );
};

export default HomepageFooterSection;
